import React from 'react';
import { connect } from 'react-redux';
import { DeveloperProjectSection, IDeveloperProject } from 'utils/entities';
import { ProjectSection } from 'screens/DeveloperPage/components/projects/ProjectSection';
import { State } from 'store/state';
import { promotedDeveloperProjectsSelector } from 'screens/DeveloperPage/selectors';


const PromotedProjects: React.FC<{ projects: IDeveloperProject[] }> = ({ projects }) => (
  <ProjectSection
    key={DeveloperProjectSection.Promoted}
    section={DeveloperProjectSection.Promoted}
    projects={projects}
    headingTagH3
  />
);

const mapStateToProps = (state: State) => ({
  projects: promotedDeveloperProjectsSelector(state),
});

export default connect(mapStateToProps)(PromotedProjects);
